import React, { Component,Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { Layout } from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './custom.css';
import './assets/css/main.css';
import './assets/css/responsive-main.css';

import './assets/css/style.main.css';
import "primereact/resources/themes/lara-light-cyan/theme.css";

import { PrimeReactProvider } from 'primereact/api';

// Optional: Create a nice loading component
const LoadingSpinner = () => (
  <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

export default class App extends Component {
  static displayName = App.name;

  render() {
    return (
       <PrimeReactProvider>
      <Layout>
        <ScrollToTop />
        {/* 2. Wrap Routes in Suspense. This fixes the blank screen error. */}
        <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          {AppRoutes.map((route, index) => {
            const { element, ...rest } = route;
            return <Route key={index} {...rest} element={element} />;
          })}
        </Routes>
        </Suspense>
      </Layout>
      </PrimeReactProvider>
    );
  }
}
